import { NumberInput } from '@core/components/Inputs';
import CurrencyTextField from '@core/components/Inputs/CurrencyTextField';
import ReadOnlyInput from '@core/components/Inputs/ReadOnlyInput';
import { Checkbox, Collapse, Divider, FormControlLabel, Grid, IconButton, Tooltip } from '@material-ui/core';
import SelectProduto from 'app/components/Select/SelectProduto';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { MdHighlightOff } from 'react-icons/md';
import { compraProdutoItemStyles } from './styles';

const getCurrency = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);

const CompraProdutoItemPure = ({
  id,
  errors,
  touched,
  name,
  values,
  arrayHelpers,
  index,
  onChange,
  onRemove,
  onBlur,
  showDivider,
  submitCount,
  compraPaga,
}) => {
  const [open, setOpen] = useState(false);
  const [disableConsumoAtivo, setDisableConsumoAtivo] = useState(false);
  const [imobilizadoTeste, setImobilizadoTeste] = useState(false);

  const _errors = {
    produto: (submitCount > 0 || touched?.produto) && errors?.produto,
    quantidade: (submitCount > 0 || touched?.quantidade) && errors?.quantidade,
    valor: (submitCount > 0 || touched?.valor) && errors?.valor,
  };

  useEffect(() => {
    setOpen(true);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleRemove = () => {
    arrayHelpers.remove(index);
    onRemove(values);
  };

  const styles = compraProdutoItemStyles();

  const subtotal = getCurrency((values?.quantidade || 0) * (values?.valor || 0));

  const maximo9DigitosEsquerda = (values) => {
    return !values.floatValue || values.floatValue <= 10 ** 9;
  };

  const produtoId = values?.produto?.id;
  useEffect(() => {
    if (produtoId) {
      if (values?.produto?.possuiVenda) {
        setDisableConsumoAtivo(true);
      } else {
        if (values?.imobilizado) {
          setImobilizadoTeste(true);
        } else {
          setImobilizadoTeste(false);
        }
        setDisableConsumoAtivo(false);
      }
    }
    // Efeito reativo apenas ao gatilho listado; incluir as demais dependências alteraria
    // quando o efeito dispara.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [produtoId]);

  const handleChange = (e) => {
    if (e?.target?.value?.possuiVenda) {
      setImobilizadoTeste(false);
      setDisableConsumoAtivo(true);
    } else {
      setDisableConsumoAtivo(false);
    }

    onChange({ target: { id: e.target.id, value: e.target.value } });
  };

  return (
    <Collapse in={open} onExited={handleRemove}>
      <div className={styles.produtoAnimacaoContainer}>
        <Grid className={clsx('mt-8', styles.produtoContainer)} container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4} className={styles.produtoNomeContainer} container>
            <Grid item xs={11}>
              <SelectProduto
                id={`${id}.produto`}
                name={`${name}.produto`}
                label="Nome do produto"
                error={_errors.produto}
                touched={!!_errors.produto}
                onChange={(e) => {
                  handleChange(e);
                }}
                onBlur={onBlur}
                value={values?.produto}
                disabled={compraPaga}
              />
            </Grid>
            <Grid xs={1} className={styles.containerInfo} item>
              {values?.produto?.descricaoDetalhada && (
                <Tooltip title={values?.produto?.descricaoDetalhada} placement="right-end">
                  <button type="button" onClick={() => {}}>
                    <FaInfoCircle size={22} style={{ color: '#555' }} />
                  </button>
                </Tooltip>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={2} xl={1}>
            <NumberInput
              id={`${id}.quantidade`}
              label="Quantidade"
              decimalScale={6}
              decimalSeparator=","
              allowNegative={false}
              isAllowed={maximo9DigitosEsquerda}
              onChange={onChange}
              onBlur={onBlur}
              value={values?.quantidade}
              error={_errors.quantidade}
              touched={!!_errors?.quantidade}
              disabled={compraPaga}
              required
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
            <CurrencyTextField
              outputFormat="number"
              decimalCharacter=","
              digitGroupSeparator="."
              maximumValue="999999999"
              minimumValue="0"
              decimalPlaces={4}
              decimalPlacesShownOnBlur={4}
              decimalPlacesShownOnFocus={4}
              error={!!_errors.valor}
              helperText={_errors.valor}
              onChange={(e, value) => {
                onChange({
                  target: {
                    id: `${id}.valor`,
                    value: e.target.value === '' ? '' : value,
                  },
                });
              }}
              onBlur={onBlur}
              id={`${id}.valor`}
              name={`${id}.valor`}
              value={values?.valor}
              fullWidth
              variant="outlined"
              label="Valor (R$) *"
              disabled={compraPaga}
              hideCurrencySymbol
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={1} xl={1}>
            <ReadOnlyInput id={`${id}.subtotal`} label="Subtotal(R$)" value={subtotal} />
          </Grid>
          <Grid item xs={11} sm={5} md={3} lg={2} xl={3}>
            <Tooltip title="Não realiza movimentação de estoque">
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    id={`${id}.imobilizado`}
                    name={`${name}.imobilizado`}
                    value={values?.imobilizado}
                    checked={imobilizadoTeste}
                    onChange={(event) => {
                      onChange(event);
                      setImobilizadoTeste(!imobilizadoTeste);
                    }}
                    onBlur={onBlur}
                    disabled={compraPaga || disableConsumoAtivo}
                  />
                }
                label="Consumo próprio / Ativo imobilizado"
              />
            </Tooltip>
          </Grid>
          <Grid item xs={1} sm={1} md={1} lg={1} xl={1} className={styles.buttonRemoveContainer}>
            {index > 0 && (
              <Tooltip title="Remover produto" placement="right-end">
                <IconButton onClick={handleClose} disabled={compraPaga}>
                  <MdHighlightOff size={18} />
                </IconButton>
              </Tooltip>
            )}
          </Grid>
        </Grid>
        {showDivider && <Divider className="mt-8" />}
      </div>
    </Collapse>
  );
};

const areEqual = (prevProps, nextProps) => {
  const {
    values: prevProduto,
    showDivider: prevShowDivider,
    errors: prevErrors,
    touched: prevTouched,
    index: prevIndex,
    submitCount: prevSubmitCount,
    compraPaga: prevCompraPaga,
  } = prevProps;
  const {
    values: nextProduto,
    showDivider: nextShowDivider,
    errors: nextErrors,
    touched: nextTouched,
    index: nextIndex,
    submitCount: nextSubmitCount,
    compraPaga: nextCompraPaga,
  } = nextProps;

  const fieldsProdutoAreEqual = Object.keys(nextProduto).reduce(
    (eq, key) => prevProduto[key] === nextProduto[key] && eq,
    true
  );

  const errorsAreEqual = Object.keys(nextErrors || {}).reduce(
    (eq, key) => prevErrors && prevErrors[key] === nextErrors[key] && eq,
    true
  );

  const touchedAreEqual = Object.keys(nextTouched || {}).reduce(
    (eq, key) => prevTouched && prevTouched[key] === nextTouched[key] && eq,
    true
  );

  const indexAreEqual = prevIndex === nextIndex;

  const submitCountAreEqual = prevSubmitCount === nextSubmitCount;

  return (
    indexAreEqual &&
    submitCountAreEqual &&
    fieldsProdutoAreEqual &&
    errorsAreEqual &&
    touchedAreEqual &&
    prevShowDivider === nextShowDivider &&
    prevCompraPaga === nextCompraPaga
  );
};

const CompraProdutoItem = React.memo(CompraProdutoItemPure, areEqual);

export default CompraProdutoItem;
